<template>
  <el-card :body-style="{ padding: 0, }"
           :class="$setClasses">
    <div :class="$vClass('img-wrapper')">
      <div :class="$vClass('img-wrapper__img')"
           :style="{'background-image': `url(${offer.mover.customLogo})`}">
    </div>
    </div>
    <p :class="$vClass('name')">{{ offer.mover.customName }}</p>
    <div v-if="offer.mover.idem_rating"
         :class="$vClass('rating')">
      <stars :class="$vClass('rating__stars')"
             :note="offer.mover.idem_rating"
             :note-max="5" />
      {{ offer.mover.idem_rating || 0 }} / 5
    </div>
    <div v-else
         :class="$vClass('no-rating')">
      {{ $t('home.comparator.noRating') }}
    </div>
    <h3 v-if="!hidePrice" :class="$vClass('price')">
      {{ $n(price, 'currency') }} {{ $tc('base.priceType', exclTax) }}
    </h3>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Stars from '@/utils/components/Stars.vue';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'comparatorOffer',
  nameClassStyle: 'comparator-offer',
  components: {
    Stars,
  },
  props: {
    offer: {
      type: Object,
      default: () => ({}),
    },
    hidePrice: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      projectSelected: 'projectStore/projectSelected',
    }),
    exclTax() {
      return this.demandStore.show_price_ht;
    },
    price() {
      return offersHelper.getPrice(this.offer, this.exclTax);
    },
  },
};
</script>

<style lang="scss" scoped>
.comparator-offer {
  padding: 0;
  background-color: $--color-panel;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 12px 0;
  }
  &__img-wrapper {
    padding: 15px 0;
    background-color: $--color-white;
    &__img {
      height: 70px;
      background-color: $--color-white;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
  &__name {
    margin: 20px;
    @include breakpoint(tablet) {
      height: 60px;
      margin: 10px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    text-transform: uppercase;
    color: $--color-primary;
    text-align: center;
  }
  &__rating {
    text-align: center;
    margin-bottom: 20px;
    color: $--color-primary;
    &__stars {
      color: $--color-secondary;
    }
  }
  &__price {
    border-radius: 4px;
    padding: 10px;
    margin: 0 20px 20px;
    text-align: center;
    background-color: $--color-white;
    color: $--color-primary;
  }
  &__no-rating {
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>
